import { BrandKitAvatar } from 'types'
import { isAvatarInRotation } from 'components/AvatarPickerModal/AvatarPickerModal'
import { useBrandKitAvatars } from 'hooks/queries/brandKits/useBrandKitAvatars'

export const anyAvatarInRotation = (avatars?: BrandKitAvatar[]): boolean => (avatars ?? []).some(isAvatarInRotation)

export const useHasInRotationAvatars = ({ brandKitId }: { brandKitId?: number }) => {
  const { data: avatars, isLoading, isSuccess } = useBrandKitAvatars({ brandKitId })
  return { hasInRotationAvatars: anyAvatarInRotation(avatars), isLoading, isSuccess }
}
